/**
 * SFrame251 — Financial reconciliation dashboard (Phase 8).
 */

import { useParams, Link } from 'react-router-dom';
import FinancialReconciliation from '../settlement/FinancialReconciliation';
import { useSettlement } from '../../contexts/SettlementContext';

import SettlementStepPage from '../settlement/SettlementStepPage';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';
export default function SFrame251() {
  const { estateId } = useParams<{ estateId: string }>();
  const { isArchived } = useSettlement();
  const suffix = estateId ? `/${estateId}` : '';
  
  const step = SETTLEMENT_PHASE_CONFIGS.close.steps.find((s) => s.id === 'cls-1')!;

  return (
    <SettlementStepPage
      step={step}
      phase="close"
      overviewRoute="/sframe-250"
    >
      <FinancialReconciliation estateId={estateId ?? null} readOnly={isArchived} />
      <div className="flex flex-wrap gap-4 text-sm text-slate-700 print:hidden">
        <Link to={`/sframe-252${suffix}`} className="font-medium text-blue-800 hover:underline">
          Next: Accounting supplements →
        </Link>
      </div>

    </SettlementStepPage>
  );
}
